import abi from './Transactions.json'

export const contractAddress = '0x62D4fa15EDc0272568B722F0CFb77E42dB98c1Cb'
export const contractABI = abi.abi
